



























import { Component, Prop, Mixins } from "vue-property-decorator";
import { IInvoice } from "@/models/invoices";
import Context from "@/mixins/context";
import { DataModules } from "@/store/modules/data";
import PaymentProvider from "@/components/app/global/payments/paymentProvider.vue";
import { SelectedPaymentMethod } from "@/models/selectPaymentMethod";
import { PaymentTarget } from "@/models/externalAuth";
import { IPaymentDetail } from "@/models/paymentDetails";
import { GatewayContext } from "@/data/enums/gateway";

@Component({
  components: {
    "select-payment-method": () =>
      import("@/components/app/global/payments/selectPaymentMethodComp.vue")
  }
})
export default class InvoiceChangePaymentMethodModal extends Mixins(
  PaymentProvider,
  Context
) {
  @Prop({ required: true })
  public invoice!: IInvoice;

  @Prop({ default: "" })
  public preselectedStoredPaymentMethodId!: IPaymentDetail["id"];

  public processing = false;

  public get selectPaymentMethodBindings() {
    return {
      autoSelectFirstGateway: false,
      autoSelectFirstStoredPaymentMethod: false,
      brandId: this.invoice.brand_id,
      clientId: this.invoice.client_id,
      currencyId: this.invoice.currency_id,
      currencyCode: this.invoice.currency?.code,
      externalAuthReturnLocation: this.externalAuthReturnLocation,
      gatewayContext: GatewayContext.ADD,
      isDisabled: this.processing,
      preselectedGatewayId: this.invoice.payment_details_id
        ? 0
        : this.invoice.gateway_id,

      preselectedStoredPaymentMethodId:
        this.preselectedStoredPaymentMethodId || this.invoice.payment_details_id
    };
  }

  public get isChanged() {
    return (
      this.$_.get(this.paymentMethod, "data.gateway_id") !==
        this.invoice.gateway_id ||
      this.$_.get(this.paymentMethod, "data.payment_details_id") !==
        this.invoice.payment_details_id
    );
  }

  public get externalAuthReturnLocation() {
    return this.buildResolver({
      returnLocation: this.$store.getters[
        `data/${DataModules.INVOICES}/getRoute`
      ](this.invoice.id, this.invoice.client_id),
      initPay: this.isExternalStore
        ? {
            invoiceId: this.invoice.id,
            target: PaymentTarget.INVOICE_CHANGE_PAYMENT_METHOD
          }
        : undefined
    }).location;
  }

  public async changePaymentMethod() {
    if (!this.isChanged || !this.hasValidPaymentMethod) {
      return;
    }
    this.processing = true;
    try {
      this.$_.set(
        this.paymentMethod as SelectedPaymentMethod,
        "data.store",
        true
      );
      await this.preparePaymentData(this.invoice.client_id);
      await this.$store.dispatch(
        `data/${DataModules.INVOICES}/updatePaymentDetails`,
        {
          id: this.invoice.id,
          isClient: this.isClient,
          data: {
            payment_details_id: this.$_.get(
              this.paymentData,
              "payment_details_id"
            )
          }
        }
      );
      this.$emit("payment-method-changed");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
    this.processing = false;
  }
}
